import { generateUUID } from '@kathondvla/sri-client/common-utils';

const peppolDirectory = require('@kathondvla/sri-client/fetch-sri-client')({
  baseUrl: 'https://directory.peppol.eu',
});

export const fetchPeppolDirectoryResponse = async (identifier) => {
  try {
    const response = await peppolDirectory.getRaw(`/search/1.0/json?q=${identifier.replace(/[\.\-\_]/g, '')}`);
    return response;
  } catch (error) {
    console.error('Error fetching Peppol Directory response:', error);
    return null;
  }
}

export const createAccountingEmail = (domain, emailAddress, organisationalUnitHref, project) => {
  const key = generateUUID();
  return {
    $$meta: {
      permalink: `/${domain}/organisationalunits/accountingdetails/${key}`,
    },
    key,
    organisationalUnit: {
      href: organisationalUnitHref,
    },
    value: {
      email: emailAddress,
    },
    project: project ? project : undefined,
    type: 'EMAIL',
  };
};

export const createGln = (domain, gln, organisationalUnitHref) => {
  const key = generateUUID();
  return {
    $$meta: {
      permalink: `/${domain}/organisationalunits/externalidentifiers/${key}`,
    },
    key,
    organisationalUnit: {
      href: organisationalUnitHref,
    },
    value: gln,
    type: 'GLN',
  };
};

export const createGlobalPeppolIdentifier = (domain, idHref, organisationalUnitHref) => {
  const key = generateUUID();
  return {
    $$meta: {
      permalink: `/${domain}/organisationalunits/accountingdetails/${key}`,
    },
    key,
    organisationalUnit: {
      href: organisationalUnitHref,
    },
    peppolIdentifier: {
      href: idHref,
    },
    type: 'GLOBAL_PEPPOL_IDENTIFIER',
  };
};

export const createLocalPeppolIdentifier = (domain, idHref, relationHref) => {
  const key = generateUUID();
  return {
    $$meta: {
      permalink: `/${domain}/organisationalunits/accountingdetails/${key}`,
    },
    key,
    organisationalUnitRelation: {
      href: relationHref,
    },
    peppolIdentifier: {
      href: idHref,
    },
    type: 'LOCAL_PEPPOL_IDENTIFIER',
  };
};

export const createCompanyNumber = (domain, companyNumber, organisationalUnitHref) => {
  const key = generateUUID();
  return {
    $$meta: {
      permalink: `/${domain}/organisationalunits/externalidentifiers/${key}`,
    },
    key,
    organisationalUnit: {
      href: organisationalUnitHref,
    },
    value: companyNumber,
    type: 'COMPANY_NUMBER',
  };
};

/**
 * Validates GLN (Global Location Number) format and check digit using Modulo 10 algorithm
 * @param {string} gln - The 13-digit GLN to validate
 * @returns {boolean} - True if GLN is valid, false otherwise
 */
export const validateGLNchecksum = (gln) => {
  // Must be exactly 13 digits (already checked by JSON schema, but double check here)
  if (!/^[0-9]{13}$/.test(gln)) {
    return false;
  }

  // Extract the first 12 digits for check digit calculation
  const digits = gln.substring(0, 12);
  const checkDigit = parseInt(gln.charAt(12), 10);

  // Calculate check digit using GS1 standard algorithm
  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    const digit = parseInt(digits.charAt(i), 10);
    // From left to right: even indices get multiplier 1, odd indices get multiplier 3
    const multiplier = i % 2 === 0 ? 1 : 3;
    sum += digit * multiplier;
  }

  // Calculate the check digit
  const calculatedCheckDigit = sum % 10 === 0 ? 0 : 10 - (sum % 10);

  return checkDigit === calculatedCheckDigit;
};